import React, { useState, useEffect, useRef } from 'react';
import { CashDepositList } from './CashDepositList';
import { toast } from 'react-toastify';
import axios from 'axios';
import dayjs from 'dayjs';
import { BankList, DateFilter, DutyList } from '@C/Utils';
import { authHeader } from '@H';
import { authService } from '@S';
import SimpleReactValidator from 'simple-react-validator';

const CashDeposit = () => {
  const [state, setState] = useState({
    payment_list: [
      {
        bank_id: '',
        payment_method: 'NEFT',
        transaction_source: 'SELF',
        product_type: 'CashDeposit',
        product_uuid: null,
        amount: '',
        notes: '',
      },
    ],
    staff_id: authService.currentUserId || '',
    time_stamp: dayjs().format('YYYY-MM-DD'),
    // time_stamp: new Date().toISOString().split('T')[0],
    updated: false,
    isSubmitting: false,
  });

  const [, forceUpdate] = useState();
  const validator = useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } }),
  );

  const handleBankChange = (e) => {
    setState((prevState) => ({
      ...prevState,
      payment_list: [
        {
          ...prevState.payment_list[0],
          bank_id: e?.value,
        },
      ],
    }));
  };

  const handleAmountChange = (e) => {
    setState((prevState) => ({
      ...prevState,
      payment_list: [
        {
          ...prevState.payment_list[0],
          amount: e.target.value,
        },
      ],
    }));
  };

  const handleNotesChange = (e) => {
    setState((prevState) => ({
      ...prevState,
      payment_list: [
        {
          ...prevState.payment_list[0],
          notes: e.target.value,
        },
      ],
    }));
  };

  const onDateChange = (e) => {
    setState((prevState) => ({
      ...prevState,
      time_stamp: e.target.value,
    }));
  };

  const handleStaffChange = (e) => {
    setState((prevState) => ({
      ...prevState,
      staff_id: e?.value || '',
    }));
  };

  const submitForm = (e) => {
    e.preventDefault();
    if (!validator.current.allValid()) {
      validator.current.showMessages();
      forceUpdate(Math.random());
      return;
    }
    setState((prevState) => ({
      ...prevState,
      isSubmitting: true,
    }));
    const formData = state;
    const headers = authHeader(1);
    axios
      .post(`${process.env.API_URL}/payment/cash-deposit/`, formData, {
        headers,
      })
      .then(() => {
        toast.success('Transaction added successfully');

        setState((prevState) => ({
          ...prevState,
          payment_list: [
            {
              bank_id: '',
              payment_method: 'NEFT',
              transaction_source: 'SELF',
              product_type: 'CashDeposit',
              product_uuid: null,
              amount: '',
              notes: '',
            },
          ],
          staff_id: '',
          time_stamp: dayjs().format('YYYY-MM-DD'),
          updated: !prevState.updated,
          isSubmitting: false,
        }));
        validator.current.hideMessages();
        forceUpdate(Math.random());
      })

      .catch((err) => {
        toast.error('Bank not selected');
        setState((prevState) => ({
          ...prevState,
          isSubmitting: false,
        }));
      });
  };

  return (
    <>
      <section className="widget full-width">
        <header>
          <h3>Cash deposit to bank</h3>
        </header>
        <main className="sub-wrapper">
          <form className="inline">
            <div className="input-wrapper with-label ">
              <label> Date:</label>
              <DateFilter
                name="selectDate"
                onChange={onDateChange}
                value={state.time_stamp}
              />
            </div>
            <div className="input-wrapper with-label">
              <label>Bank</label>
              {validator.current.message(
                'bank',
                state.payment_list[0].bank_id,
                'required',
              )}
              <BankList
                id="settlement_bank"
                handleBankChange={handleBankChange}
                value={state.payment_list[0].bank_id}
              />
            </div>

            <div className="input-wrapper with-label">
              <label>Amount</label>
              {validator.current.message(
                'amount',
                state.payment_list[0].amount,
                'required|numeric',
              )}
              <input
                type="text"
                name="amount"
                value={state.payment_list[0].amount}
                onChange={handleAmountChange}
              />
            </div>
            <div className="input-wrapper with-label">
              <label>Notes</label>
              <input
                type="text"
                name="notes"
                value={state.payment_list[0].notes}
                onChange={handleNotesChange}
              />
            </div>
            <div className="form-actions">
              <button
                className="submit"
                disabled={state.isSubmitting}
                onClick={submitForm}
              >
                Submit
              </button>
            </div>
          </form>
        </main>
      </section>
      <CashDepositList key={state.updated} />
    </>
  );
};

export { CashDeposit };
